import FitterFee from './fitter_fee';
export default class FitterService extends FitterFee {
    constructor(props) {
        super(props);
    }
}
